export default __webpack_public_path__ + "static/soehne-web-dreiviertelfett-d38f0685faccceecc1ffb0595a867bc7.woff";